<div></div><template>

  <form id="form-contactenos">
  <p v-show="mensajeEstado" v-bind:class="claseEstado" v-html="mensajeEstado"></p>
    <p>Send us your questions. We will respond shortly. </p>
    <div class="form-group">
      <label for="nombre"></label>
      <input v-model="nombre" placeholder="Name" type="text" name="nombre">
    </div>
    <div class="form-group">
      <label for="tel"></label>
      <input v-model="tel" placeholder="Telephone" type="tel" name="tel">
    </div>
    <div class="form-group">
      <label for="email"></label>
      <input v-model="email" placeholder="Email" type="mail" name="Email">
    </div>
    <div class="form-group">
      <label for="consulta"></label>
      <textarea v-model="consulta" placeholder="Comments" name="consulta"></textarea>
    </div>
    <div class="boton">
      <button v-on:click.prevent="enviarFormulario" type="submit" name="dsubmit" value="Submit">Send</button>
    </div>
  </form>


</template>

<script>
export default {
  name: 'FormContactenosEN',
  data () {
    return {
      nombre: '',
      tel: '',
      email: '',
      consulta: '',
      estado: '',
      mensajeEstado: ''
    }
  },

  computed: {
    claseEstado () {
      return 'alert alert-' + this.estado
    }
  },

  methods: {
    enviarFormulario: function (evento) {
      this.$http.get('http://synapsis.com.ar/test/formulario/mega.php', {
        params: {
          token: 'DrKrxX0Gjl243B38QDjg4EgppGDNh8vl',
          SenderName: this.nombre,
          tel: this.tel,
          SenderAddress: this.email,
          consulta: this.consulta
        },
        before: function (request) {
          this.estado = 'info'
          this.mensajeEstado = 'Enviando...'
        }
      }).then(response => {
        if (response.body.error !== 'false') {
          this.estado = 'success'
          this.mensajeEstado = response.body.mensaje

          // Borro los datos del form
          this.nombre = ''
          this.tel = ''
          this.email = ''
          this.consulta = ''
        } else {
          this.estado = 'danger'
          this.mensajeEstado = response.body.mensaje
        }
      }, response => {
        this.estado = 'danger'
        this.mensajeEstado = response.body.mensaje
      })
    }
  }
}
</script>

<style scoped lang="sass">
form 
  font-size: 0
  display: flex
  flex-direction: column
  align-items: center
  .form-group
    width: 100%
    display: flex
    justify-content: center
p
  font-size: 20px
  color: #323232
label 
 display: none
input, textarea 
  width: 100%
  max-width: 560px
  height: 40px
  font-size: 12px
  padding-left: 10px
  outline: 0
  &::placeholder
    font-size: 16px
    color: #323232
textarea 
  height: 90px
.boton 
  width: 100%
  display: flex
  justify-content: flex-end
  margin-right: 164px
  button 
    padding: 9px 30px
    background: #004D9E
    color: #fff
    text-transform: uppercase
    letter-spacing: 1px
    border: solid 1px #004D9E
    @extend %animacion-suave
    &:hover
      background: #fff
      color: #004D9E
%animacion-suave 
  -webkit-transition: all .35s ease-in-out
  -moz-transition: all .35s ease-in-out
  -o-transition: all .35s ease-in-out
  -ms-transition: all .35s ease-in-out
  transition: all .35s ease-in-out
button 
  border: solid 1px #004D9E
  padding: 0 10px
  background: #fff
  color: #004D9E
  cursor: pointer
  font-weight: 700
  font-size: 16px
  @extend %animacion-suave
  &:hover
    background: #004D9E
    color: #fff
</style>



// WEBPACK FOOTER //
// src/components/contactenos-en/form-contactenos-en.vue